import axios from 'axios'
import debounce from 'just-debounce-it'
import { showToast, TOAST_TYPES } from 'ToastUtils'

let store
export const injectStore = (_store) => {
  store = _store
}

const { REACT_APP_API_URL, REACT_APP_FORWARDED_FOR } = process.env
const baseAPIURL = REACT_APP_API_URL

const axiosJWT = axios.create({ baseURL: baseAPIURL })
const axiosNoJWT = axios.create({ baseURL: baseAPIURL })

if (REACT_APP_FORWARDED_FOR) {
  //Add a request interceptor

  console.log('FORWARDING FOR', REACT_APP_FORWARDED_FOR)

  axiosNoJWT.interceptors.request.use(
    (config) => {
      config.headers['x-forwarded-for'] = REACT_APP_FORWARDED_FOR
      config.baseURL = baseAPIURL
      return config
    },
    (error) => {
      return error
    },
  )
}

const sessionExpired = debounce(() => {
  showToast(TOAST_TYPES.INFO, 'Session expired')
  localStorage.clear()
  sessionStorage.clear()
  return new Promise((resolve, reject) => {
    setTimeout(resolve, 2000)
  }).then(() => {
    window.location.reload()
    return []
  })
}, 500)

// Add a request interceptor
axiosJWT.interceptors.request.use(
  (config) => {
    const { token } = store.getState().credentials
    config.headers.Authorization = `Bearer ${token}`

    config.baseURL = baseAPIURL
    return config
  },
  (error) => {
    console.error(`APIHttpClient Request Error:  ${error}`)
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      return sessionExpired().then(() => error)
    }
    return Promise.reject(error)
  },
)

axiosJWT.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      await sessionExpired().then(() => error)
    }
    return Promise.reject(error)
  },
)

// const refreshAccessToken = async () => {
//   const user = localStorage.getItem('user')
//   const userData = JSON.parse(user)
//   try {
//     const { data } = await axios.post(`${baseAPIURL}/auth/refreshtoken`, {
//       jwt: userData.accessToken,
//       refreshToken: userData.refreshToken,
//     })

//     const { jwtToken, refreshToken } = data
//     store.dispatch(UpdateTokens({ accessToken: jwtToken, refreshToken }))

//     userData.accessToken = jwtToken
//     userData.refreshToken = refreshToken
//     localStorage.setItem('user', JSON.stringify(userData))
//     return true
//   } catch (error) {
//     store.dispatch(LogoutRequest())
//     return false
//   }
// }

// const showToastNetworkError = debounce(() => {
//   showToast(TOAST_TYPES.ERROR, 'Network error')
// }, 500)

// const showToastSessionExpired = debounce(() => {
//   showToast(TOAST_TYPES.INFO, 'Session expired')
// }, 500)

// Response interceptor for API calls

// axiosJWT.interceptors.response.use(
//   (response) => {
//     return response
//   },
//   async (error) => {
//     const originalRequest = error.config
//     const { response } = error
//     if (!response) {
//       showToastNetworkError()
//     } else if (response.status === 401 && !originalRequest.retry) {
//       originalRequest.retry = true
//       const updated = await refreshAccessToken()
//       if (updated) {
//         return axiosJWT(originalRequest)
//       }
//       showToastSessionExpired()
//     } // axios.defaults.headers.common.Authorization = 'Bearer ' + access_token

//     return Promise.reject(error)
//   },
// )

const APIAuthClient = {
  get: axiosJWT.get,
  post: axiosJWT.post,
  put: axiosJWT.put,
  delete: axiosJWT.delete,
  patch: axiosJWT.patch,
}

const APIClient = {
  get: axiosNoJWT.get,
  post: axiosNoJWT.post,
  put: axiosNoJWT.put,
  delete: axiosNoJWT.delete,
  patch: axiosNoJWT.patch,
}

export { APIClient, APIAuthClient }
